<nav>
	<ul class="nav" style="cursor: pointer; flex-direction: column">
		<li class="nav-divider"></li>
		<a class="pl-1 nav-link nav-dropdown-toggle" (click)="toggle()">
			<i class="pi pi-angle-{{ minimized ? 'right' : 'left' }}"></i>
			<span>{{ minimized ? '' : 'Nascondi' }}</span>
		</a>
	</ul>
</nav>
